import { reatomAsync } from "@reatom/async";
import { API } from "src/api";
import { toastHandler } from "src/util";

import { getUserApiTokens } from "./getUserApiKeys";

export const removeUserApiToken = reatomAsync(
  (_ctx, token: string) => API.tokenApi.apiTokenControllerDeleteApiToken(token),
  "removeUserApiToken",
);

removeUserApiToken.onFulfill.onCall((ctx) => {
  toastHandler.warning({
    title: "Ключ удален!",
    name: "keydeleted",
  });
  getUserApiTokens(ctx);
});
